export default {
  templates: `/v1/skills/templates`,
  template: (id: string) => `/v1/skills/templates/${id}`,
  available_skills: `/v1/skills/templates/available_skills`,
  exists_skills: (id: string) => `/v1/skills/templates/${id}/exists_skills`,
  block_skills: (id: string) => `/v1/skills/templates/${id}/block_skills`
};
